if (!customElements.get("td-shipping-bar")) {
    class TDShippingBar extends HTMLElement {
        constructor() {
            super();
            this.abortController = null;
            this.PROGRESS_BAR_CLASS = '.td-shipping-bar__bar-progress';
            this.PROGRESS_MESSAGE_CLASS = '.td-shipping-bar__message';
            this.PROGRESS_CONTAINER_CLASS = '.td-shipping-bar__container';

            this.progressBar = this.querySelector(this.PROGRESS_BAR_CLASS);
            this.progressBarContainer = this.querySelector(this.PROGRESS_CONTAINER_CLASS);
            this.progressMessage = this.querySelector(this.PROGRESS_MESSAGE_CLASS);
        }
    
        connectedCallback() {
            this.abortController = new AbortController();
            const listenerOptions = { signal: this.abortController.signal };

            document.addEventListener('ajaxProduct:added', () => {
                this.cartTotal();
            }, listenerOptions)
            document.addEventListener('cart:updated', () => {
                this.cartTotal();
            }, listenerOptions)
        }

        disconnectedCallback() {
            if (this.abortController) {
                this.abortController.abort();
                this.abortController = null;
            }
        }

        updateUI(detail) {
            const minimum = Number(this.progressBarContainer && this.progressBarContainer.dataset.shippingMin);
            const cartTotal = Number(detail);

            if (
                !this.progressBar ||
                !this.progressBarContainer ||
                !this.progressMessage ||
                !Number.isFinite(minimum) ||
                minimum <= 0 ||
                !Number.isFinite(cartTotal)
            ) {
                return;
            }

            const progressTotalPercent = Math.min(100, Math.max(0, (cartTotal / minimum) * 100));
            const progressTotalRemaining = Math.max(0, minimum - cartTotal);
            const completeMessage = this.progressBarContainer.dataset.completeMessage;
            const remainingMessage = this.progressBarContainer.dataset.remainingMessage;

            this.progressBar.style.width = `${progressTotalPercent}%`;

            if (progressTotalPercent >= 100) {
                if (completeMessage) {
                    this.progressMessage.innerHTML = completeMessage;
                }
                return;
            }

            if (remainingMessage) {
                const remainingMoney = window.theme && theme.Currency
                    ? theme.Currency.formatMoney(progressTotalRemaining * 100, theme.settings.moneyFormat)
                    : progressTotalRemaining.toFixed(2);
                this.progressMessage.innerHTML = remainingMessage.replace('[amount]', remainingMoney);
            }
        }

        // GET CART QUANTITY AJAX/LOGIC
        async cartTotal() {
            try {
                const response = await fetch(`${window.location.origin}/cart.js`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }
                });
        
                if (response.status === 200) {
                    const {total_price} = await response.json();

                    if (Number.isFinite(total_price)) {
                        const priceInDollars = total_price / 100;
                        this.updateUI(priceInDollars);
                    }
                }

            } catch (err) {
                console.log(err);
            }
        }
    }

    customElements.define("td-shipping-bar", TDShippingBar);
}
